import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import Settings from './components/settings';
import Stacks from './components/stacks';

//hidden, candidate for removing DFSA-791
class NHLNonControlledStack extends Component {
    useFilter(use) {
        this.props.dispatch(Action.do('useNHLNonControlledStack', !use));
        if (!use) {
            this.props.dispatch(Action.do('useNHLNameStack', use));
        }
    }

    render() {
        let {sportConfig, stack} = this.props;

        if (!sportConfig.isReady()) {
            return false;
        }

        return (
            <div className={`advanced-filter${stack.useStack ? ' advanced-open' : ''}`}>
                <div className="advanced-top">
                    <button
                        type="button"
                        onClick={(e) => ::this.useFilter(stack.useStack)}
                        className="btn-close-filter"
                    >
                        <i className="fa fa-times-circle"></i>Disable non controlled stacking
                    </button>
                    <button type="button" onClick={(e) => ::this.useFilter(stack.useStack)} className="advanced-opener">
                        <i className="fa fa-cog"></i>Enable non controlled stacking
                    </button>
                </div>

                <Settings />
                <Stacks />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, stacks} = state;
    return {
        sportConfig,
        stack: stacks.nonControlled,
    };
}

export default connect(mapStatesToProps)(NHLNonControlledStack);
